import { Button, CircularProgress, type ButtonProps } from '@mui/material';

type LoadingButtonProps = {
  isLoading: boolean;
} & ButtonProps;

export const LoadingButton = ({ children, disabled, isLoading, ...props }: LoadingButtonProps) => (
  <Button
    {...props}
    disabled={isLoading || disabled}
    endIcon={isLoading ? <CircularProgress aria-label="In progress" /> : null}
  >
    {children}
  </Button>
);
